import { primaryColor } from "../../../data-service/backend-functions/helpers";
import problem from "../../../images/icon/problem.svg";
import redArrow from "../../../images/icon/redArrow.svg";
import solution from "../../../images/icon/solution.svg";
import tick from "../../../images/icon/tick-square.svg";
export const TargetAdvantages = () => {
  return (
    <section className="section-sp2">
      <div className="container inner-content">
        <h2 className="text-center">NPI Targeting Advantages</h2>
        <h3 className="text-center" style={{ color: primaryColor }}>
          Receive Actionable Insights Without Relying on Form Fills
        </h3>
        <div className="solution-cards">
          <div
            className="problem-card"
            style={{
              background: "#FFF7F7",
              maxWidth: "630px",
              padding: "30px",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
            }}
          >
            <img src={problem} alt="" />
            <h3 style={{ color: "#EC0D0D", marginBlock: "10px" }}>
              The Problem
            </h3>
            <h4>
              Are you finding it difficult to prove the impact of your marketing
              efforts to your leadership?
            </h4>
            <p>
              Engaging and educating HCPs through digital campaigns can be
              challenging—especially when success is measured by form fills,
              which many providers are hesitant to complete.
            </p>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <img src={redArrow} alt="" />
            </div>
          </div>
          <div
            className="solution-card"
            style={{
              background: "#FCFFF9",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
              maxWidth: "630px",
              padding: "30px",
            }}
          >
            <img src={solution} alt="" />
            <h3 style={{ color: "##7BD825", marginBlock: "10px" }}>
              The Solution
            </h3>
            <span>
              To bridge this gap and provide clearer insights, we deliver
              detailed reporting, including Physician Level Data (PLD). You can
              see exactly which HCPs viewed and/or clicked your ads—no form
              fills required.
            </span>
            <p style={{ fontWeight: "bold" }}>
              Now, you can confidently demonstrate how marketing is driving
              real, measurable results—and even tie it to ROI.
            </p>
            <h6 style={{ color: primaryColor }}>
              Reporting includes the following:
            </h6>
            <div style={{ display: "flex", gap: "5px" }}>
              <img src={tick} alt="" />
              Monthly campaign reports and scheduled calls
            </div>
            <div style={{ display: "flex", gap: "5px" }}>
              <img src={tick} alt="" />
              Monthly Physician Level Data (PLD) reports
            </div>
            <div style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              End-of-campaign wrap-up report with performance metrics, deep
              insights, and actionable recommendations
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
